import React from 'react';
import "../../styles.css";

function LevelSelectDescription(props) {
    return (
        <div className='levelSelectDesc'>
            {props.text}
        </div>
    );
}

export default LevelSelectDescription